import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_DOWNLOAD} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Download = lazy(() =>
  import('../../../screens/Download')
    .then(module => ({default: module.Download})));

const DownloadNavigation = [
  {
    path: ROUTE_DOWNLOAD,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Download />
      </Suspense>
    ),
  },
];

export default DownloadNavigation;
